const getters = {
    error: state => state,
    status: state => state.status,
    statusText: state => state.statusText,
    options: state => state.options,
    route: state => JSON.parse(JSON.stringify(state.options.route)),
    isError: state => !!state.status,
};

export default getters;